const wowApp = require('angular').module('wowApp.shop');

wowApp.service('CategoriesService', ['$rootScope', '$state', 'Restangular', '$q', 'BreakpointsService', 'LoginService', 'ShopperService', 'BootstrapService', 'PageMetadataService', '$timeout', 'FeatureService', require('./categories-service')]);

wowApp.directive('wowCategoriesNavigation', ['MoveFocus', 'BreakpointsService', require('./categories-navigation-directive')]);

wowApp.directive('bwsCategory', ['BreakpointsService', '$location', 'CategoriesService', '$templateCache', 'RRPubSub', '$state', 'SearchService', '$rootScope', '$window', 'CurationService', require('./categories-directive')]);
wowApp.directive('bwsCategorySearchList', ['CacheService', '$location', 'SearchService', '$state', 'SettingsService', 'CatalogService', 'DecorateAdditionalDetails', 'CategoriesService', 'RRPubSub', 'PageMetadataService', '$window', '$timeout', 'FiltersService', 'AtmService', require('./product-list-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/index.js
 **/